import Handlebars from "handlebars";
import { modules } from "../../main";

export class View {
    private name: string;
    private template: ( data: string ) => any;

    public constructor( name: string, template: string ) {
        this.name = name;

        try {
            this.template = Handlebars.compile( template );
        } catch (error) {
            throw new Error( "Das folgende Templae hat einen Fehler: " + this.name );
        }
    }

    public process( data: Object, debug: boolean = false ): string {
        try {
            let result: string = this.template( data as any );

            if ( result != "" ) {
                result = ( debug ? "<!--" + this.name + "-->" : "" ) + result;
            }

            return result;
        } catch (error) {
            modules.error( "Beim verarbeiten des folgenden Templates ist ein Fehler aufgetretet: " + this.name );

            return null;
        }
    }

    public getName(): string {
        return this.name;
    }

    public getTemplate(): ( data: string ) => any {
        return this.template;
    }
}